var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 26,
    viewBox: "0 0 50 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 22,
    rx: 11,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7695 10.5352V10.9395C13.7695 11.5879 13.6816 12.1699 13.5059 12.6855C13.3301 13.2012 13.082 13.6406 12.7617 14.0039C12.4414 14.3633 12.0586 14.6387 11.6133 14.8301C11.1719 15.0215 10.6816 15.1172 10.1426 15.1172C9.60742 15.1172 9.11719 15.0215 8.67188 14.8301C8.23047 14.6387 7.84766 14.3633 7.52344 14.0039C7.19922 13.6406 6.94727 13.2012 6.76758 12.6855C6.5918 12.1699 6.50391 11.5879 6.50391 10.9395V10.5352C6.50391 9.88281 6.5918 9.30078 6.76758 8.78906C6.94336 8.27344 7.19141 7.83398 7.51172 7.4707C7.83594 7.10742 8.21875 6.83008 8.66016 6.63867C9.10547 6.44727 9.5957 6.35156 10.1309 6.35156C10.6699 6.35156 11.1602 6.44727 11.6016 6.63867C12.0469 6.83008 12.4297 7.10742 12.75 7.4707C13.0742 7.83398 13.3242 8.27344 13.5 8.78906C13.6797 9.30078 13.7695 9.88281 13.7695 10.5352ZM11.9941 10.9395V10.5234C11.9941 10.0703 11.9531 9.67188 11.8711 9.32812C11.7891 8.98438 11.668 8.69531 11.5078 8.46094C11.3477 8.22656 11.1523 8.05078 10.9219 7.93359C10.6914 7.8125 10.4277 7.75195 10.1309 7.75195C9.83398 7.75195 9.57031 7.8125 9.33984 7.93359C9.11328 8.05078 8.91992 8.22656 8.75977 8.46094C8.60352 8.69531 8.48438 8.98438 8.40234 9.32812C8.32031 9.67188 8.2793 10.0703 8.2793 10.5234V10.9395C8.2793 11.3887 8.32031 11.7871 8.40234 12.1348C8.48438 12.4785 8.60547 12.7695 8.76562 13.0078C8.92578 13.2422 9.12109 13.4199 9.35156 13.541C9.58203 13.6621 9.8457 13.7227 10.1426 13.7227C10.4395 13.7227 10.7031 13.6621 10.9336 13.541C11.1641 13.4199 11.3574 13.2422 11.5137 13.0078C11.6699 12.7695 11.7891 12.4785 11.8711 12.1348C11.9531 11.7871 11.9941 11.3887 11.9941 10.9395ZM21.9785 6.46875V15H20.2207L16.793 9.28125V15H15.0352V6.46875H16.793L20.2266 12.1934V6.46875H21.9785Z",
    fill: "#22C55E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1031_8604)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1031_8604)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 2,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#22C55E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1031_8604",
    x: 24,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.137255 0 0 0 0 0.0431373 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1031_8604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1031_8604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1031_8604"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 2,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSwitch);
export default __webpack_public_path__ + "static/media/ActiveSwitch.820f08839c4ff0082fae8798b7c1fec6.svg";
export { ForwardRef as ReactComponent };